import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TResetState = IAction<ETicketPayment.RESET_STATE, null>

const resetState = (): TResetState => ({
    type: ETicketPayment.RESET_STATE,
    payload: null,
});

export default resetState;
